import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import SettingsSidebar from '../../components/SidebarV2/SettingsSidebar';
import useAnalytics from '../../hooks/useAnalytics';
import SettingsMainContent from './SettingsRoot.styles';

const SettingsRoot: React.FC = () => {
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.capture('settings_viewed', {});
  }, []);

  return (
    <>
      <div className="sidebar">
        <SettingsSidebar />
      </div>

      <SettingsMainContent className="mainContent">
        <Outlet />
      </SettingsMainContent>
    </>
  );
};

export default SettingsRoot;
